import { FC, Select, SingleValue } from 'external/react'
import { TeacherContext } from 'teacher/context'
import { useContext } from 'external/react'
import { initialState } from 'context/index'

type SelectFieldProps = {
    options: {value: any, label: string}[],
    onChange: any,
    className?: string
    isMulti?: boolean
    label: string,
    selectStyles?: any,
    value?: SingleValue<{value: any, label: string}>
}

export const SelectField: FC<SelectFieldProps> = ({ options, onChange, label, selectStyles, value, className, isMulti}) => {
    const context: any = useContext(TeacherContext) as typeof initialState

    return (
        <div className={className} style={{display: 'flex', justifyContent: 'center', gap: '8px', flexDirection: 'column', width: '100%'}}>
            {label && <div>
                <label style={{height: '60px'}}>
                    {label}
                </label>
            </div>}
            <div style={{flex: 1}}>
                <Select
                    styles={selectStyles}
                    classNamePrefix="select"
                    formatOptionLabel={({ label }) => label}
                    isMulti={isMulti}
                    isSearchable={false}
                    isClearable={false}
                    escapeClearsValue={true}
                    getOptionValue={({ value }) => value}
                    placeholder={context.translate("pick_one")}
                    value={value}
                    onChange={onChange}
                    options={options}
                    
                />
            </div>
        </div>
    )
}